import { store } from '../store'
import router from '../router'

export const goHome = function () {
    let currentUser = store.getters.currentUser
    switch (true) {
        case currentUser.user_types.producer.id !== undefined:
            router.push('/dashboard/producer')
            break
        case currentUser.user_types.general_agents.id !== undefined:
            router.push('/dashboard/general-agent')
            break
        default:
            router.push('/dashboard')
            break
    }
}
